import { BaseTradeService } from '../../base-trade.service';
import { ProjectOrganizationResponseDto } from '../dto/response/project-organization-response.dto';
import { ProjectOrganizationSaveRequestDto } from '../dto/request/project-organization-save-request.dto';
import { ProjectOrganizationUpdateRequestDto } from '../dto/request/project-organization-update-request.dto';
import { BuyerResponseDto } from '../../../buyerAPI/buyer/dto/response/buyer-response.dto';
import buyerService from '../../../buyerAPI/buyer/services/buyer.service';
import { ProjectOrganizationRelationType } from '../project-organization-relation-type';

class ProjectSupportersService extends BaseTradeService {
  public async fetchProjectSupportersByLandscapeProjectId(
    id: string
  ): Promise<ProjectOrganizationResponseDto[]> {
    const response = await this.get<ProjectOrganizationResponseDto[]>(
      `/projectsupporters/getbycompactprojectid/${id}`
    );
    return response.data;
  }

  public async fetchProjectSupportersBySupporterId(
    id: string
  ): Promise<ProjectOrganizationResponseDto[]> {
    const response = await this.get<ProjectOrganizationResponseDto[]>(
      `/projectsupporters/${id}`
    );
    return response.data;
  }

  public async fetchProjectSupportersByOrganizationId(
    id: string
  ): Promise<ProjectOrganizationResponseDto[]> {
    const response = await this.get<ProjectOrganizationResponseDto[]>(
      `/projectsupporters/getbyorganizationid/${id}`
    );
    return response.data;
  }

  public async fetchProjectSupportersByProjectId(
    id: string,
    relationShipType: ProjectOrganizationRelationType
  ): Promise<BuyerResponseDto[]> {
    const projectSupporters =
      await this.fetchProjectSupportersByLandscapeProjectId(id);
    const filteredProjectSupporters = projectSupporters.filter(
      (supp) => supp.relationType === relationShipType
    );
    const supporterIds = filteredProjectSupporters.map((supporter) => {
      return supporter.organizationId;
    });
    const buyers = await buyerService.fetchBuyers();
    return buyers.filter((buyer) => supporterIds.includes(buyer.id));
  }

  public async saveProjectSupporters(
    saveRequest: ProjectOrganizationSaveRequestDto
  ): Promise<ProjectOrganizationResponseDto> {
    const response = await this.post<ProjectOrganizationResponseDto>(
      `/projectsupporters`,
      saveRequest
    );
    return response.data;
  }

  public async updateProjectSupporters(
    updateRequest: ProjectOrganizationUpdateRequestDto
  ): Promise<ProjectOrganizationResponseDto> {
    const response = await this.put<ProjectOrganizationResponseDto>(
      `/projectsupporters`,
      updateRequest
    );
    return response.data;
  }

  public async deleteProjectSupporters(id: string): Promise<void> {
    await this.delete<void>(`/projectsupporters/${id}`);
  }
}

const projectSupportersService = new ProjectSupportersService();

export default projectSupportersService;
